import { ZSet, zTuple } from "../ZSet";
import { type LinearOperatorLogic } from "./LinearOperatorLogic";

export type Projection<TInput, TOutput> = (tuple: TInput) => TOutput;

export function select<TInput, TOutput>(
	projection: Projection<TInput, TOutput>
): LinearOperatorLogic<TOutput, TInput, null> {
	return (input: ZSet<TInput>, state: null): [ZSet<TOutput>, null] => {
		let output = ZSet.empty<TOutput>();

		for (const tuple of input) {
			const inputValue = tuple.tuple.getValue() as TInput;
			const outputValue = projection(inputValue);
			output = output.add(zTuple(tuple.tuple.id, outputValue, tuple.weight));
		}

		return [output, state];
	};
}
